var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.imageData,"height":_vm.height,"width":_vm.width,"max-height":_vm.maxHeight,"max-width":_vm.maxWidth,"min-height":_vm.minHeight,"min-width":_vm.minWidth,"contain":_vm.contain,"aspect-ratio":_vm.aspectRatio,"content-class":_vm.contentClass}})
}
var staticRenderFns = []

export { render, staticRenderFns }